// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1122":"2d7a22fc","6708":"7cc90aa0"}[chunkId] + ".chunk.css";
};